module.exports = __webpack_public_path__ + "static/data_and_analytics-70e50f96bc2158d5437a8372f01c56e2.jpg";